import { render, staticRenderFns } from "./ProductOmnibusPopup.vue?vue&type=template&id=b0703f60&scoped=true&"
import script from "./ProductOmnibusPopup.vue?vue&type=script&lang=ts&"
export * from "./ProductOmnibusPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0703f60",
  null
  
)

export default component.exports